<main class="password-page">
  @if(showForm) {
  <ion-card class="">
    <ng-container>
      <!-- <app-general-error [code]="error"/> -->
      <app-card-header-title-subtitle
        title="forgot-password-regeneration.title"
        subtitle="forgot-password-regeneration.subtitle"
      />

      <ion-card-content class="ion-no-padding password-form">
        <form
          [formGroup]="forgotPassRegForm"
          novalidate
          (submit)="submitForm()"
        >
          <ion-row class="password-form__inputs">
            <ion-col size="12" sizeMd="6">
              <app-input
                [formGroup]="forgotPassRegForm"
                label="forgot-password-regeneration.password"
                formControlName="password"
                maxlength="50"
                type="password"
                [required]="true"
              />
            </ion-col>

            <ion-col size="12" sizeMd="6">
              <app-input
                [formGroup]="forgotPassRegForm"
                label="forgot-password-regeneration.confirm-password"
                formControlName="validation_password"
                maxlength="50"
                type="password"
                [required]="true"
              />
            </ion-col>
          </ion-row>
          <div
            class="password-form__requirements"
            [innerHTML]="
              'registration-form-simple.password-requirements' | translate
            "
          ></div>

          <ion-row class="password-form__buttons">
            <ion-col size="12" sizeMd="2">
              <a
                (click)="handleRedirect()"
                state="{ blockRouting: true }"
                class="m-0 button-link button-link-outline"
              >
                {{ 'forgot-password-regeneration.btn-back' | translate }}
              </a>
            </ion-col>
            <ion-col size="12" sizeMd="3">
              <ion-button
                #button
                class="ion-float-right button-solid m-0"
                expand="block"
                type="submit"
                [disabled]="!forgotPassRegForm.valid"
              >
                {{ 'forgot-password-regeneration.btn-accept' | translate }}
              </ion-button>
            </ion-col>
          </ion-row>
        </form>
      </ion-card-content>
    </ng-container>
  </ion-card>
  } @if(showResponse) {
  <app-auth-verification-handler
    view="forgot-password-regeneration"
    [process]="process"
    (goBackClicked)="goBackFromVerification($event)"
  />
  }
</main>
